import React, { Component } from 'react';
import RatingStars5 from "../../../common/ratingStars5";
import InputText from "../../../pages/pageParts/inputForms/inputText";


import '../../../index.scss';

class CombinedCharacteristics extends Component {
    constructor(props) {
        super(props);
        this.onCompetitorChange = this.onCompetitorChange.bind(this);
        this.receiveRating = this.receiveRating.bind(this);
        this.state = {
            loading: true,
            competitor: this.props.competitor,
            content: this.props.content ? JSON.parse(this.props.content) : {},
            options: this.props.options,
            tooltipOpen: {}

        }

        this.headerStyle = {
            fontWeight: "600",
            fontSize: "16px",
            lineHeight: "30px",
            color: "#355681",
            padding: "6px 0px 0px 0px"
            }

        this.rankStyle = {
            fontWeight: "600",
            fontSize: "16px",
            lineHeight: "30px",
            color: "#355681",
            padding: "6px 0px 0px 0px"
            }
            
        this.labelStyle = {fontSize: "16px", fontWeight: 'bold'};

    }

    updateContents(rankOnly) {

        this.props.updateContents(this.state.competitor, JSON.stringify(this.state.content), rankOnly)
    }

    onCompetitorChange(evt) {
        var id = evt.target.id
        if (id.startsWith("comments")) id = "comments";
        
        const val = evt.target.value
        let state = this.state;
        state.content[id] = val;
        this.setState(state);

        this.updateContents(false);
    }

    receiveRating = (id, rating) => {
        
        let state = this.state;
        state.content[id] = rating;
        state.content.points = this.state.options.reduce((a,b) => a + (state.content[b.key] || 0), 0)   
        this.setState(state);

        this.updateContents(false);
        
    };

    setRank(allPoints) {
        let state = this.state;
        if (allPoints) {
            const points = state.content.points;
            var rank = 1
            for(const oPoints of allPoints) {
                if (points < oPoints) rank++;
            }

            state.content.rank = rank;
            state.loading = false;
            this.setState(state);
            this.updateContents(true);
        }
    }

    componentDidMount() {
        this.setRank(this.props.allPoints)
    }

    componentDidUpdate(prevProps) {
        if(prevProps.allPoints !== this.props.allPoints) {
            this.setRank(this.props.allPoints)
        }
    }

    toggleToolTip(key) {
        const tooltipOpen = this.state.tooltipOpen;
        if (!tooltipOpen[key]) tooltipOpen[key] = false;
        tooltipOpen[key] = !tooltipOpen[key];
        this.setState({tooltipOpen});
    }
  
    render(){
        if (this.state.loading) { return null; }
        const {competitor, options, content} = this.state;
        const space = 4;
        return (
            <div className="card">
                <div className="card-body" style={{paddingTop: "0px", paddingBottom: "0px"}}>
                    <div className="row">
                        <div className="col-6">
                            <label style={this.headerStyle}>{competitor.displayname}</label>                                                 
                        </div>
                        <div className="col-6 ">
                            <div className="float-right">
                                <label style={this.labelStyle}>Rank: {content.rank || 0}</label>
                            </div> 
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6">
                            <label style={this.headerStyle}>{competitor.role}</label>
                        </div>
                        <div className="col-6">
                            <div className="float-right">
                                <label style={this.rankStyle}>Total Speaker Points: {content.points || 0}</label>
                            </div> 
                        </div>
                    </div>

                    <hr style={{paddingTop: "0px", marginTop: "0px"}}/>

                    {options.map(option => {
                        const keykey = option.key+'_'+competitor.userId;
                        return (
                        <div className="row">
                            <div className="col-7">
                                <label id={`ltt_${keykey}`} style={this.labelStyle}>{option.title}:</label>{option.tip && option.tip.trim() !== '' && (<span style={{ fontSize: '12px' }}>({option.tip})</span>)}
                            </div>
                            <div className="col-5">
                                <RatingStars5 readOnly={this.props.readOnly} id={keykey} space={space} rating={content[option.key]} receiveRating={(rating) => this.receiveRating(option.key,rating)}/> 
                            </div>
                        </div>
                    )})}

                    <hr style={{paddingTop: "0px", margin: "0px"}}/>
                    <div className="row">
                        <div className="col-12">
                            <InputText label="Speaker Feedback:" id={"comments_"+competitor.userId} value={content.comments} 
                            onChange={this.onCompetitorChange} 
                            placeholder="" readOnly={this.props.readOnly} autoResize />
                        </div>
                    </div>                                                                              
                </div>
            </div>    
        )
    }
}

export default CombinedCharacteristics;